import { useState } from 'react'

const FormularioVoluntario = ({ onSubmit, onCancel, editando = null }) => {
  const [form, setForm] = useState({
    nombre: editando?.nombre || '',
    email: editando?.email || '',
    telefono: editando?.telefono || '',
    cedula: editando?.cedula || '',
    password: '',
    rol: editando?.rol || 'voluntario',
    zona_operativa: editando?.zona_operativa || '',
    vehiculo: editando?.vehiculo || false
  })

  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (!editando && form.password.length < 6) {
      setError('La contrasena debe tener al menos 6 caracteres')
      return
    }

    setLoading(true)
    try {
      await onSubmit(form)
    } catch (err) {
      setError(err.message || 'Error al guardar voluntario')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="modal-overlay" onClick={(e) => e.target.className === 'modal-overlay' && onCancel()}>
      <div className="modal-card">
        <div className="modal-header-form">
          <h3>{editando ? 'Editar Voluntario' : 'Agregar Voluntario'}</h3>
          <button className="modal-close-btn" onClick={onCancel}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body-form">
            {error && <div className="form-error-msg">{error}</div>}

            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Nombre completo</label>
                <input
                  name="nombre"
                  value={form.nombre}
                  onChange={handleChange}
                  placeholder="Ej: Juan Perez"
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="correo@ejemplo.com"
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Telefono</label>
                <input
                  name="telefono"
                  value={form.telefono}
                  onChange={handleChange}
                  placeholder="0412-3456789"
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Cedula</label>
                <input
                  name="cedula"
                  value={form.cedula}
                  onChange={handleChange}
                  placeholder="V-12345678"
                  required
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Contrasena {editando ? '(dejar vacio para mantener)' : ''}</label>
                <input
                  name="password"
                  type="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder={editando ? "Nueva contrasena (opcional)" : "Minimo 6 caracteres"}
                  required={!editando}
                  className="form-input"
                />
              </div>

              <div className="form-group">
                <label className="form-label">Rol</label>
                <select name="rol" value={form.rol} onChange={handleChange} className="form-select">
                  <option value="voluntario">Voluntario</option>
                  <option value="admin">Admin</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Zona operativa</label>
                <select name="zona_operativa" value={form.zona_operativa} onChange={handleChange} className="form-select">
                  <option value="">Seleccionar zona...</option>
                  <option value="Catia La Mar">Catia La Mar</option>
                  <option value="Caraballeda">Caraballeda</option>
                  <option value="Maiquetia">Maiquetia</option>
                  <option value="La Guaira Centro">La Guaira Centro</option>
                  <option value="Otra">Otra</option>
                </select>
              </div>

              <div className="form-group checkbox-group">
                <label className="checkbox-label-form">
                  <input
                    name="vehiculo"
                    type="checkbox"
                    checked={form.vehiculo}
                    onChange={handleChange}
                  />
                  <span>Posee vehiculo propio</span>
                </label>
              </div>
            </div>
          </div>

          <div className="modal-footer-form">
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancelar</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Guardando...' : editando ? 'Actualizar' : 'Crear Voluntario'}
            </button>
          </div>
        </form>
      </div>

      <style>{`
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 16px;
        }
        .modal-card {
          background: white;
          border-radius: 16px;
          width: 100%;
          max-width: 560px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 60px rgba(0,0,0,0.2);
        }
        .modal-header-form {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          border-bottom: 1px solid #E2E8F0;
        }
        .modal-header-form h3 {
          font-size: 1.15rem;
          font-weight: 700;
          color: #1A365D;
          margin: 0;
        }
        .modal-close-btn {
          background: none;
          border: none;
          font-size: 1.5rem;
          cursor: pointer;
          color: #A0AEC0;
          padding: 4px 8px;
          line-height: 1;
        }
        .modal-close-btn:hover {
          color: #4A5568;
        }
        .modal-body-form {
          padding: 20px 24px;
        }
        .modal-footer-form {
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          padding: 16px 24px;
          border-top: 1px solid #E2E8F0;
        }
        .form-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 14px;
        }
        .form-error-msg {
          grid-column: 1 / -1;
          padding: 10px 14px;
          background: #FFF5F5;
          border: 1px solid #FED7D7;
          border-radius: 8px;
          font-size: 0.85rem;
          color: #C53030;
          margin-bottom: 4px;
        }
        .checkbox-group {
          display: flex;
          align-items: flex-end;
          padding-bottom: 4px;
        }
        .checkbox-label-form {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.9rem;
          color: #4A5568;
          cursor: pointer;
        }
        .checkbox-label-form input[type="checkbox"] {
          width: 18px;
          height: 18px;
          accent-color: #4299E1;
          cursor: pointer;
        }
        .form-select {
          width: 100%;
          padding: 12px 14px;
          border: 1.5px solid #E2E8F0;
          border-radius: 10px;
          font-size: 0.92rem;
          font-family: 'Inter', sans-serif;
          color: #2D3748;
          background: white;
          outline: none;
          transition: border-color 0.2s;
        }
        .form-select:focus {
          border-color: #4299E1;
          box-shadow: 0 0 0 3px rgba(66,153,225,0.12);
        }
        @media (max-width: 500px) {
          .form-grid {
            grid-template-columns: 1fr;
          }
          .modal-card {
            max-width: 100%;
          }
        }
      `}</style>
    </div>
  )
}

export default FormularioVoluntario